import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { Capacitor } from '@capacitor/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'fun-viewer',
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.scss']
})
export class ViewerComponent implements OnInit, OnChanges {

  @Input() file: any;
  @Input() imageList: any;
  @Input() zoom: any;
  @Input() maxHeight: any;
  @Output() public errorEvent = new EventEmitter<any>();
  @Output() public pageChangeEvent = new EventEmitter<any>();
  @Output() public pageNumberEvent = new EventEmitter<any>();

  loading: boolean;
  zoomNumber;
  pdfSrc: any;

  constructor(public chdRef: ChangeDetectorRef, private authService: AuthService) { }

  ngOnInit() {
    // Must be set before <pdf-viewer> is created (i.e. before pdfSrc is assigned)
    // so that ng2-pdf-viewer's constructor picks up our local worker
    // instead of falling back to the CDN
    (window as any).pdfWorkerSrc = 'assets/pdf.worker.min.js';

    this.zoomNumber = this.zoom !== null && this.zoom !== undefined ? this.zoom : 1.7;
    this.pageChangeEvent.emit({ pageNumber: 1 });
    this.chdRef.detectChanges();
  }

  ngOnChanges() {
    this.loading = true;
    this.pdfSrc = undefined;
    this.loadPdf();
    this.chdRef.detectChanges();
  }

  loadPdf() {
    if (!this.file) {
      return;
    }

    if (typeof this.file !== 'string' || !Capacitor.isNativePlatform()) {
      // Web: pass URL directly, pdfjs fetches it internally
      this.pdfSrc = this.file;
      return;
    }

    // Native: fetch PDF on the main thread (CapacitorHttp-patched, bypasses
    // CORS and adds auth header) then pass as an object with httpHeaders so
    // pdfjs does not need to make its own unauthenticated network request
    const token = this.authService.authData?.accessToken;
    this.pdfSrc = token
      ? { url: this.file, httpHeaders: { Authorization: `Bearer ${token}` }, withCredentials: false }
      : { url: this.file };
    this.chdRef.detectChanges();
  }

  callBackFn(event) {
    this.loading = false;
    this.chdRef.detectChanges();
  }

  onError(event) {
    this.errorEvent.emit();
    this.chdRef.detectChanges();
  }

  pagechanging(event) {
    this.pageChangeEvent.emit(event);
    this.chdRef.detectChanges();
  }

  afterLoadComplete(pdf: PDFDocumentProxy) {
    this.pageNumberEvent.emit(pdf.numPages);
    this.chdRef.detectChanges();
  }

}
